import axios from 'axios';
import ENV from '../constants/Environment.js';
export default new class BibleService {

    async getBooks() {
        const response = await axios.get(`${ENV.HEROKU_API_ENDPOINT}/bible/books`);
        return response.data.results;
    }

    async getChapter(pSelected) {
        const response = await axios.get(`${ENV.HEROKU_API_ENDPOINT}/bible/${pSelected.version}/${pSelected.book.name}/${pSelected.chapter}`);
        return response.data.results;
    }

}
